import script from "./OrderExistedTipModal.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderExistedTipModal.vue?vue&type=script&setup=true&lang=js"

import "./OrderExistedTipModal.vue?vue&type=style&index=0&id=09a84cd0&lang=less"
import "./OrderExistedTipModal.vue?vue&type=style&index=1&id=09a84cd0&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09a84cd0"]])

export default __exports__